import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface AppOrderState {
  isFactoryOrder: boolean;
}

const initialState: AppOrderState = {
  isFactoryOrder: false,
};

const appOrderSlice = createSlice({
  name: 'appOrder',
  initialState,
  reducers: {
    setIsFactoryOrder: (state, action: PayloadAction<boolean>) => {
      state.isFactoryOrder = action.payload;
    },
  },
});

export const { setIsFactoryOrder } = appOrderSlice.actions;
export default appOrderSlice.reducer;
